import React, {useEffect, useState} from 'react';
import ModalForm from '../../../components/modalComponents/ModalForm'
import GenericModal from "../../../components/modal/GenericModal";
//import { Div } from '../../../components/Components';
import {useSubmitForm} from "../../../hooks/useSubmitForm/useSubmitForm";
import InputSearchAsync from '../../../components/modalComponents/InputSearchAsync';
import AsyncSelectInputGET from "../../../components/Select/AsyncSelectInputGET";
import {getColaboradorWithFecIng, habilitarHistorialEmpleadoAPI, deshabilitarHistorialEmpleadoAPI} from "../../../consumers/backendApisUrls";
import SpinnerLoading from '../../../components/pageComponents/SpinnerLoading';
import { usePropsInputs } from '../../../hooks/useProps/usePropsInput';
import { isNullOrUndefinded } from '../../../helper/utils';
import InputCheckBox from "../../../components/modalComponents/InputCheckBox";

const SECTION_NAME = "HabilitarHistorialModal";
const HabilitarHistorialModal = ({toggleModal, refreshTable}) => {
    const [submitForm] = useSubmitForm();
    const [formValues, setFormValues] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
    const [currentIdEmpleado, setCurrentIdEmpleado] = useState(0);
    const [acceptBOL, setAcceptBOL] = useState(false);
    const [acceptCTS, setAcceptCTS] = useState(false);
    const [acceptUTI, setAcceptUTI] = useState(false);
    const [errors, setErrors] = useState({ IdEmpleado: '', ValueForBoleta: '' });

    useEffect(() => {
    if (!isNullOrUndefinded(formValues?.IdEmpleado))
    {
        setCurrentIdEmpleado(formValues?.IdEmpleado);
        setErrors((prev) => ({ ...prev, IdEmpleado: '' }));       
    }        
    }, [formValues?.IdEmpleado])


    // Depuración: Monitorear formValues
    useEffect(() => {
        console.log('formValues:', formValues);
        console.log('IdEmpleado:', formValues?.IdEmpleado);
    }, [formValues]);

    // Manejar cambio en AsyncSelectInputGET
    const handleColaboradorChange = (selectedOption) => {
        const newIdEmpleado = selectedOption ? selectedOption.value : null;
        console.log('Selected option:', selectedOption); // Depuración
        console.log('New IdEmpleado:', newIdEmpleado); // Depuración
        setFormValues((prev) => ({ ...prev, IdEmpleado: newIdEmpleado }));
        setErrors((prev) => ({ ...prev, IdEmpleado: '' })); // Limpiar error
    };

     const successResponseCallback = (response) => {
        refreshTable();
        toggleModal();
    }

    const handleDesactivar = async(e) =>{
        e.preventDefault();
        setIsSubmitting(true);
        let newErrors = { IdEmpleado: '', ValueForBoleta: '' };
        let isValid = true;

        if (isNullOrUndefinded(formValues?.IdEmpleado) || formValues.IdEmpleado === 0) {
            newErrors.IdEmpleado = 'Debes seleccionar un colaborador';
            isValid = false;
        }

        if (!acceptBOL) {
            newErrors.ValueForBoleta = 'Debes marcar la casilla de Boleta de Pago';
            isValid = false;
        }

        setErrors(newErrors);
        if (isValid) { //isValid
            let payload= {
                "IdEmpleado":formValues.IdEmpleado,
                "ValueForBoleta": acceptBOL,
                "ValueForCts": acceptCTS,
                "ValueForUtilidad": acceptUTI
            };
            let keys = ["IdEmpleado","ValueForBoleta"];            
            try {
                await submitForm(keys, deshabilitarHistorialEmpleadoAPI(), payload, SECTION_NAME, successResponseCallback)
            }catch (error) {
                console.error(error);
            } finally {
                setTimeout(() => {
                    setIsSubmitting(false);
                }, 1000);
            }
        }else{
            setIsSubmitting(false);
        }   
    }

    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);  
                
        let newErrors = { IdEmpleado: '', ValueForBoleta: '' };
        let isValid = true;

        if (isNullOrUndefinded(formValues?.IdEmpleado) || formValues.IdEmpleado === 0) {
            newErrors.IdEmpleado = 'Debes seleccionar un colaborador';
            isValid = false;
        }

        if (!acceptBOL || !acceptCTS) {
            newErrors.ValueForBoleta = 'Debes seleccionar al menos una casilla de Documento';
            isValid = false;
        }

        setErrors(newErrors);

        if (isValid) { //isValid
            let payload= {
                "IdEmpleado":formValues.IdEmpleado,
                "ValueForBoleta": acceptBOL,
                "ValueForCts": acceptCTS,
                "ValueForUtilidad": acceptUTI
            };
            let keys = ["IdEmpleado","ValueForBoleta"];            
            try {
                await submitForm(keys, habilitarHistorialEmpleadoAPI(), payload, SECTION_NAME, successResponseCallback)
            }catch (error) {
                console.error(error);
            } finally {
                setTimeout(() => {
                    setIsSubmitting(false);
                }, 1000);
            }
        }else{
            setIsSubmitting(false);
        }     
    };

    
    if (isLoading) return <SpinnerLoading />

    return(

        <GenericModal showModal={toggleModal} width={"730px"} titulo="Activar Historial de Documentos de Pago">
            <div className="margin-modal-body">
                <form className="black-color-important">
                    <div className="row custom-form-group-modal mb-0">
                        <label className="col-sm-3 col-form-label modal-label">Colaborador<span className="required">*</span></label>
                        <div className="col-sm-9 flex-row justify-content-center ">
                            <AsyncSelectInputGET api={getColaboradorWithFecIng} 
                                placeholder="Nombre y/o apellidos" 
                                handleSelectInputChange={handleColaboradorChange} // Usar prop específica 
                                value={formValues.IdEmpleado ? { value: formValues.IdEmpleado, label: formValues.FullName || '' } : null}
                            />
                            {errors.IdEmpleado && (
                                <p className="ficha-form-input-validation-message" id="add-historial-IdEmpleado-validation-message">{errors.IdEmpleado}</p>
                            )}
                        </div>
                    </div>
                    <div className="row custom-form-group-modal mb-0">
                        <label className="col-sm-3 col-form-label modal-label">Tipos documento</label>
                        <div className="col-sm-9 flex-row justify-content-center ">
                            <div className='checkbox'>
                                <label>
                                    <input
                                        checked={acceptBOL}
                                        name="ValueForBoleta"
                                        type='checkbox'
                                        onChange={(event) => setAcceptBOL(event.target.checked)}
                                        id={178578}
                                    />
                                    <span className="black-color font-gothan-light ">Boleta de Pago</span>
                                </label>
                                {errors.ValueForBoleta && (
                                    <p className='ficha-form-input-validation-message'>
                                        {errors.ValueForBoleta}
                                    </p>
                                )}
                            </div>
                            <div className='checkbox'>
                                <label>
                                    <input
                                        checked={acceptCTS}
                                        name="ValueForCts"
                                        type='checkbox'                                        
                                        onChange={(event) => setAcceptCTS(event.target.checked)}
                                        id={178579}
                                    />
                                    <span className="black-color font-gothan-light ">Carta de CTS</span>
                                </label>
                            </div>

                            <div className='checkbox'>
                                <label>
                                    <input
                                        checked={acceptUTI}
                                        name="ValueForUtilidad"
                                        type='checkbox'
                                        disabled={true}
                                        onChange={(event) => setAcceptUTI(event.target.checked)}
                                        id={178580}
                                    />
                                    <span className="black-color font-gothan-light ">Utilidad</span>
                                </label>
                            </div>                            
                        </div>                        
                    </div>
                    <div 
                     className="modal-footer d-flex justify-content-between pt-0 pb-0 "
                    //className='button_approve_decline'
                    >
                        <div className="message font-gothan-light align-self-start">
                            <button
                                className={`btn btn-primary generic-button-ficha-modal generic-button-hover-rojo`}
                                onClick={handleDesactivar}>Desactivar historial
                            </button>                            
                        </div>
                        <div className="button align-self-end">
                            <button                             
                            className={`btn btn-primary generic-button-ficha-modal generic-button-hover-verde`}
                            onClick={handleSubmit}>Activar historial</button>
                        </div>
                    </div>
                </form>
            </div>
        </GenericModal>

    )
};

export default HabilitarHistorialModal

const Div = ({ col, children }) => (
  <div className={`col-sm-${col}`}>
    {children}
  </div>
)